import React, { useMemo, useState } from 'react';

import {
  LISTING_HERO_INLINE_VARIANTS,
  LISTING_HERO_LIGHTBOX_VARIANTS,
} from '../../util/listingImageVariants';
import { getOrderedListingMedia } from '../../util/listingMedia';
import { Modal } from '../../components';

import ImageCarousel from './ImageCarousel/ImageCarousel';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';

import css from './ListingPage.module.css';

const VIEW_PHOTOS_FOCUS_ID = 'ListingPage.galleryOpenTrigger';

const SectionGallery = props => {
  const { listing, variantPrefix, onManageDisableScrolling } = props;
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  const media = useMemo(() => getOrderedListingMedia(listing), [listing]);
  // A fresh array each render makes the gallery rebuild `items` and jump back to slide 1.
  const thumbnailVariants = useMemo(
    () => [variantPrefix, `${variantPrefix}-2x`, `${variantPrefix}-4x`],
    [variantPrefix]
  );

  const openLightbox = index => {
    setLightboxIndex(typeof index === 'number' ? index : 0);
    setLightboxOpen(true);
  };

  return (
    <section className={css.productGallery} data-testid="carousel">
      <ListingImageGallery
        media={media}
        imageVariants={LISTING_HERO_INLINE_VARIANTS}
        thumbnailVariants={thumbnailVariants}
        forceAspectRatio={{ aspectWidth: 4, aspectHeight: 3 }}
        compact
        onOpenLightbox={openLightbox}
        openTriggerId={VIEW_PHOTOS_FOCUS_ID}
      />
      <Modal
        id="ListingPage.galleryLightbox"
        scrollLayerClassName={css.carouselModalScrollLayer}
        containerClassName={css.carouselModalContainer}
        lightCloseButton
        isOpen={lightboxOpen}
        onClose={() => setLightboxOpen(false)}
        usePortal
        onManageDisableScrolling={onManageDisableScrolling}
        focusElementId={VIEW_PHOTOS_FOCUS_ID}
      >
        {lightboxOpen ? (
          <ImageCarousel
            key={lightboxIndex}
            media={media}
            imageVariants={LISTING_HERO_LIGHTBOX_VARIANTS}
            thumbnailVariants={thumbnailVariants}
            initialIndex={lightboxIndex}
          />
        ) : null}
      </Modal>
    </section>
  );
};

export default SectionGallery;
